<template lang='pug'>
  .language-dropdown
    a.language-link.nav-link(:class='{ "expanded" : showLanguageOptions }' href='#' @click.prevent='toggleLanguageOptions')
      span.selected-language(v-text='languages[i18nLanguage]')
      span.caret
</template>

<script>
import { mapState } from 'vuex'
import { searchUtil } from '@/mixins/layoutUtil'

export default {
  mixins: [
    searchUtil
  ],

  computed: {
    ...mapState({
      showLanguageOptions: state => state.layout.showLanguageOptions
    }),
    languages: () => vueSupport.header.languages,
    i18nLanguage: () => I18n.language
  },

  methods: {
    toggleLanguageOptions () {
      this.$store.commit('setShowLanguageOptions', !this.showLanguageOptions)
      this.closeSearch()
    }
  }
}
</script>

<style scoped lang='scss'>
  .caret {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 4px solid;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    vertical-align: middle;
  }

  .expanded {
    color: $brand-primary;
  }

  .selected-language {
    margin-right: 5px;
  }
</style>
